import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';

import { parseAiAssistantUserMessage } from '@domain/ai-assistant/ai-assistant-ui-context';
import { AiMessageVm } from '@domain/ai-assistant/ai-assistant.view-models';

import { SiteDateTimeComponent } from '@shared/components/site-date-time';

import { appAi52Icon } from '@icons/ai-52';

import { AiOutputPartComponent } from '../ai-output-part/ai-output-part.component';
import { AiThinkingPartComponent } from '../ai-thinking-part/ai-thinking-part.component';
import { AiToolCallPartComponent } from '../ai-tool-call-part/ai-tool-call-part.component';
import { AiUiContextBoxComponent } from '../ai-ui-context-box/ai-ui-context-box.component';

@Component({
  selector: 'app-ai-message',
  imports: [
    SiteDateTimeComponent,
    SvgIconComponent,
    AiOutputPartComponent,
    AiThinkingPartComponent,
    AiToolCallPartComponent,
    AiUiContextBoxComponent,
  ],
  templateUrl: './ai-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col relative z-0' },
})
export class AiMessageComponent {
  public message = input.required<AiMessageVm>();
  public showLeadingIcon = input(true);
  public readonly userMessage = computed(() => {
    const message = this.message();
    if (message.role !== 'user') {
      return null;
    }

    const text = message.parts
      .filter((part) => part.kind === 'output')
      .map((part) => part.text)
      .join('');

    return parseAiAssistantUserMessage(text);
  });

  constructor() {
    injectRegisterIcons([appAi52Icon]);
  }
}
